import React from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import DataGrid from '../shared/DataGrid';
import OperationalFilters from './OperationalFilters';
import LiveFloorViewApi from '../../api/livefloorview';
import { prepareFilter } from '../../redux/actions/organisationDirectory';

class OperationalTab extends React.Component {

  state = {
    periods: [],
    reports: [],
    selectedPeriod: null,
    selectedReport: null,
    grid: {
      data: [],
      headerDef: [],
      rowDef: []
    }
  };

  componentDidUpdate(prevProps, prevFilters) {
    const { operator } = this.props.filters.filterSelected;
    if (operator && operator !== prevProps.filters.filterSelected.operator) {
      LiveFloorViewApi.getPeriods().then(periods => this.setState({ periods }))
      LiveFloorViewApi.getReports(operator).then(reports => this.setState({ reports }))
    }
  }

  handleChange = (key, value) => this.setState({[key]: value});
  
  handleRefresh = () => {
    this.setState({loading: true }, () => {
      const { operator, company, subcompany, site } = this.props.filters.filterSelected
      const { filterSelected, filterData } = this.props.filters

      LiveFloorViewApi.filterByOperation(
        operator,
        company.id,
        subcompany.id,
        site.id,
        prepareFilter(filterSelected.manufacturer, filterData.manufacturer),
        prepareFilter(filterSelected.game, filterData.game),
        prepareFilter(filterSelected.machinetypes, filterData.machinetypes),
        this.state.selectedPeriod,
        this.state.selectedReport
      )
      .then(
        response => this.setState({ grid: response.grid, loading: false }), 
        () => this.setState({ loading: false })
      )
    })
  }

  render() {
    const { selectedPeriod, selectedReport, periods, reports } = this.state;
    const disabled = !this.props.filters.hasSelection

    return (
      <Grid relaxed className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column width="16">
            <OperationalFilters
              disabled={disabled}
              periods={periods}
              reports={reports}
              selectedReport={selectedReport}
              selectedPeriod={selectedPeriod}
              onChange={this.handleChange}
              onRefreshClick={this.handleRefresh}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column className="gs-flex-container-vertical">
            <DataGrid
              loading={this.state.loading}
              headings={this.state.grid.headerDef}
              rowDef={this.state.grid.rowDef}
              data={this.state.grid.data}
              onRowClick={this.handleCommsViewSelection}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
};

const mapStateToProps = state => {
	return {
    filters: state.LiveFloorViewerFilters,
  };
};

export default connect(mapStateToProps)(OperationalTab);
